import AudioEditorLoader from "./AudioEditorLoader";

export default AudioEditorLoader;
